import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCountdown } from '../../helpers/hooks/useCountdown';

export const WeekTimer = ({ endsAt, className = '' }) => {
  const { t } = useTranslation();
  const { days, hours, minutes } = useCountdown(endsAt);
  return <span className={className}>{t('quests.resetsIn', { days, hours, minutes })}</span>;
};
